<template>
  <span class="text-sm text-neutral-500 line-clamp-1">
    <time>
      {{ formatDate(date) }}
    </time>
    <span
      v-if="readTime"
      class="whitespace-no-wrap"
    >
      · {{ $t('blogpost.min-read', { mins: readTime }) }}
    </span>
  </span>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'VetsterPostDate',

  props: {
    date: {
      type: String,
      required: true,
    },
    readTime: {
      type: [Number, String],
      default: null,
    },
  },

  methods: {
    formatDate(isoDate) {
      return DateTime.fromISO(isoDate).toFormat('MMMM dd, yyyy');
    },
  },
};
</script>
